import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

/**
 * Products by Collection Slider Web Component
 */
class ProductsByCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.timeoutId = null;
    this.isNestedInteraction = false;
    this.activeElement = null;

    this.enableLoop = this.dataset.enable_slider_loop === "true";
    this.sliderCentered = this.dataset.sliderCentered === "true";
    this.sliderFullWidth = this.dataset.sliderFullWidth === "true";
    this.spaceBetweenD = parseInt(this.dataset.spaceBetweenD) || 30;
    this.spaceBetweenM = parseInt(this.dataset.spaceBetweenM) || 20;

    this.nextButtonSelector = this.querySelector("[data-button-next]");
    this.prevButtonSelector = this.querySelector("[data-button-prev]");
    this.showNavigation = !!(this.nextButtonSelector && this.prevButtonSelector);

    this.nestedSelectors =
      ".card-product__image-wrapper, .card-product__slider, .card-product__image, .card-product__media, .image-carousel";
    this.isTouchDevice = "ontouchstart" in window;

    this.handleInteraction = this.handleInteraction.bind(this);
  }

  connectedCallback() {
    this.init();
    this.setupNestedSliderHandling();
  }

  init() {
    this.swiper?.destroy(true, true);

    const swiperConfig = {
      slidesPerView: "auto",
      spaceBetween: this.spaceBetweenM,
      loop: this.enableLoop,
      slidesOffsetAfter: this.enableLoop ? 0 : this.spaceBetweenM,
      nested: true,
      touchReleaseOnEdges: true,
      allowTouchMove: true,
      navigation: this.showNavigation
        ? {
            nextEl: this.nextButtonSelector,
            prevEl: this.prevButtonSelector,
          }
        : false,
      breakpoints: {
        768: {
          spaceBetween: this.spaceBetweenD,
          initialSlide: !this.enableLoop && this.sliderFullWidth ? 2 : 0,
          slidesOffsetAfter: this.enableLoop ? 0 : this.spaceBetweenD,
          slidesOffsetBefore: this.sliderFullWidth && !this.sliderCentered ? this.spaceBetweenD : 0,
          centeredSlides: this.sliderCentered,
        },
      },
    };

    try {
      this.swiper = new Swiper(this, swiperConfig);
    } catch (error) {
      console.error("Error initializing Swiper:", error);
    }
  }

  setupNestedSliderHandling() {
    const events = this.isTouchDevice ? ["touchstart", "touchend"] : ["mousedown", "mouseup", "mouseleave"];

    events.forEach((event) => {
      this.addEventListener(event, this.handleInteraction, {
        passive: event.includes("touch") ? false : true,
      });
    });
  }

  handleInteraction(event) {
    if (!this.swiper) return;

    const isStartEvent = event.type.includes("start") || event.type.includes("down");

    if (isStartEvent) {
      this.timeoutId && clearTimeout(this.timeoutId);
      this.timeoutId = null;

      this.activeElement = event.target.closest(this.nestedSelectors);

      if (this.activeElement) {
        this.swiper.allowTouchMove = false;
        this.isNestedInteraction = true;

        if (event.type === "mousedown") {
          this.activeElement.style.cursor = "grabbing";
        }
      }
    } else {
      if (this.activeElement && event.type === "mouseup") {
        this.activeElement.style.cursor = "";
      }

      this.isNestedInteraction = false;
      this.activeElement = null;

      const delay = this.isTouchDevice ? 50 : 150;

      this.timeoutId = setTimeout(() => {
        if (this.swiper && !this.isNestedInteraction) {
          this.swiper.allowTouchMove = true;
        }
        this.timeoutId = null;
      }, delay);
    }
  }

  disconnectedCallback() {
    this.timeoutId && clearTimeout(this.timeoutId);
    this.isNestedInteraction = false;
    this.activeElement = null;

    const events = this.isTouchDevice ? ["touchstart", "touchend"] : ["mousedown", "mouseup", "mouseleave"];

    events.forEach((event) => {
      this.removeEventListener(event, this.handleInteraction);
    });

    this.swiper?.destroy(true, true);
    this.swiper = null;
    this.timeoutId = null;
  }
}

if (!customElements.get("products-by-collection-slider")) {
  customElements.define("products-by-collection-slider", ProductsByCollectionSlider);
}
